import React from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const NewCustomMetricBox = ({ onCreate }) => {
  const handleClickCreate = () => {
    onCreate?.();
  };

  return (
    <div className="create-metric-box">
      <p>
        <b> Not finding the metrics you need? </b>Create custom metrics in two simple steps.
      </p>
      <Button type="primary" icon={<PlusOutlined />} onClick={handleClickCreate}>
        Create New Metrics
      </Button>
    </div>
  );
};

export default NewCustomMetricBox;
